import type { PersonioAttendanceType } from "@msuite/utils/types";
import type { IconName } from "./icons";

export function getPersonioAttendanceTypeIcon(
	type: Lowercase<PersonioAttendanceType> | PersonioAttendanceType,
): IconName {
	switch (type.toLocaleLowerCase()) {
		case "work":
			return "Hammer";
		case "break":
			return "Coffee";
		default:
			return "CircleQuestionMark";
	}
}
